import { handleAnonId } from './storage'
import {
  eraseAjsLocalStorage,
  setAjsLocalStorageByCompanyId,
} from './analytics-storage'

let loaded = false
let sourceId

export const isLoaded = () => loaded
export const setSourceId = (id) => {
  sourceId = id
}

const loadAnalytics = (companyId, callback = () => null) => {
  eraseAjsLocalStorage()
  setAjsLocalStorageByCompanyId(companyId)

  window.analytics.load = function(t, e) {
    var n = document.createElement('script')
    n.type = 'text/javascript'
    n.async = !0
    n.src = 'https://cdn.segment.com/analytics.js/v1/' + t +
      '/analytics.min.js'
    var a = document.getElementsByTagName('script')[0]
    a.parentNode.insertBefore(n, a)
    window.analytics._loadOptions = e

    n.onload = function() {
      handleAnonId()
      callback()
    }
  }
  window.analytics.SNIPPET_VERSION = '4.1.0'
  window.analytics.load(sourceId)
}

const loadAnalyticsWrapper = (companyId, callback = () => null) => {
  if (isLoaded()) {
    callback()
    return
  }

  loaded = true

  setTimeout(() => {
    loadAnalytics(companyId, callback)
  }, 500)
}

export { loadAnalyticsWrapper as loadAnalytics }
